// extracted by mini-css-extract-plugin
var _1 = "PageActions-modulePageActions__lL8Sl";
var _2 = "PageActions-moduleskeleton__Cjlmx Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "PageActions", _2 as "skeleton" }
